// Utils
import handleBlockType from './handleBlockType';
import handleInlineStyle from './handleInlineStyle';
import handleLink from './handleLink';

export default ({ enableBlockStyles }) =>
    (editorState, char) => {
        let newEditorState = editorState;

        if (enableBlockStyles) {
            newEditorState = handleBlockType(editorState, char);
        }

        if (editorState === newEditorState) {
            newEditorState = handleInlineStyle(editorState, char);
        }

        if (editorState === newEditorState) {
            newEditorState = handleLink(editorState, char);
        }

        return newEditorState;
    };
